import checkHasEmailConfig from "./check-has-email-config.js";

export default {
	checkHasEmailConfig,
};
